'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('HubStyleTokens/colors');

var _Constants = require('../../Constants');

var _AvatarContentHolder = require('./AvatarContentHolder');

var _AvatarContentHolder2 = _interopRequireDefault(_AvatarContentHolder);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _SVGIcon = require('./SVGIcon');

var _SVGIcon2 = _interopRequireDefault(_SVGIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialBadgeWrapper = (0, _styledComponents2.default)('div').withConfig({
  displayName: 'SocialBadge__SocialBadgeWrapper'
})(['align-items:center;border-radius:50%;bottom:-1%;color:', ';display:flex;font-family:sans-serif;font-size:600%;justify-content:center;position:absolute;right:-16%;user-select:none;width:64%;'], _colors.OLAF);

var SocialBadge = function SocialBadge(props) {
  var socialNetwork = props.socialNetwork;

  return _react2.default.createElement(
    SocialBadgeWrapper,
    null,
    _react2.default.createElement(
      _AvatarContentHolder2.default,
      null,
      _react2.default.createElement(_SVGIcon2.default, {
        wrapperProps: {
          style: { backgroundColor: _Constants.SOCIAL_MAP[socialNetwork].color }
        },
        y: '70',
        icon: _Constants.SOCIAL_MAP[socialNetwork].icon
      })
    )
  );
};

SocialBadge.propTypes = {
  socialNetwork: _react.PropTypes.oneOf(Object.keys(_Constants.SOCIAL_MAP))
};

exports.default = SocialBadge;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-2.1456/js/UIAvatarDisplay/baseStyledComponents/SocialBadge.js
// module id = 494
// module chunks = 171